import { CompanyService } from "../../../services/CompanyService";

const getEmailList = async function ({ commit, dispatch, state }, config) {
    const { companyId } = config
    
    try {
        const data = await CompanyService.getEmailList(companyId);
        return data;
    } catch (error) {
        console.error(error);
    }
};

export default getEmailList;